import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { EntityConfigService } from "../services/entity-config-service";
import { DateCalcService } from "../services/date-calc-service";
import { SearchService } from "../services/search-service";

export function RLViewDateCalcByCharacteristic() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/view-date-calc-by-characteristic.html"),
        controller: RLViewDateCalcByCharacteristicController,
        controllerAs: "vdcVM",
        bindToController: true,
        scope: {
            dateMath: "="
        }
    };

    return directive;
}

class RLViewDateCalcByCharacteristicController {
    static $inject = ["$scope", "$q", "$window", "$filter", "notifyService", "entityService", "entityConfigService", "dateCalcService", "searchService"];

    hasDateMath: boolean;
    dateMath: Models.ICharDataExtensionDataDateMath;
    dateMathCalcs: Models.ICharDataExtensionDataDateMathCalc[];

    relationships: Models.ICharDataExtensionDataDateMathRel[];
    childRelationships: Models.ICharDataExtensionDataDateMathRel[];

    parentInfoList: Models.ICharDataExtensionDataDateMathParentRelInfo[];
    childrenInfoList: Models.ICharDataExtensionDataDateMathChildRelInfo[];

    showDateMathError: boolean;

    timeFrameLabels: { [key: string]: string };
    frequencyLabels: { [key: string]: string };
    public dayOffsetLabels: _.Dictionary<string> = {
        "1": "+1 Day",
        "-1": "-1 Day"
    };

    isOpen: boolean;

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private $filter: ng.IFilterService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
        private dateCalcService: DateCalcService,
        private searchService: SearchService) {

        this.showDateMathError = false;

        $scope.$watch(() => this.dateMath, (newValue, oldValue) => {
            if (newValue != null) {
                this.LoadDateMath();
            }
        }, true);

        $scope.$watch(() => this.isOpen, (newValue, oldValue) => {
            if (newValue) {
                this.LoadParentInfo();
            }
        });
    }


    LoadDateMath() {
        this.hasDateMath = _.any(this.dateMath.relationships);

        this.dateMathCalcs = this.dateMath.calcs;
        this.relationships = this.dateMath.relationships;
        this.childRelationships = this.dateMath.childRelationships;

        //this.showDateMathError = _.any(this.childRelationships) && _.any(this.relationships);

        this.dateCalcService.getDateCalcTimeframeList()
            .then((result) => {
                this.timeFrameLabels = _.transform<Models.IDateCalcTimeframe, string>(result, (acc, item) => acc[item.timeframeID] = item.timeframeLabel, {});
            });

        this.dateCalcService.getDateCalcFrequencyList()
            .then((result) => {
                this.frequencyLabels = _.transform<Models.IDateCalcFrequency, string>(result, (acc, item) => acc[item.frequencyID] = item.frequencyLabel, {});
            });

    }

    LoadParentInfo() {
        if (_.any(this.relationships)) {
            var rels;
            if (this.relationships.filter(rel => rel.parentRecCharID < -1000))
            {
                //This means it is a Relative Rights Profile Relative to Catalog options, send in all the rels
                rels = this.relationships;
            }
            else
            {
                rels = this.relationships.filter(rel => rel.parentRecCharID > 0);
            }

            return this.dateCalcService.getDateMathCalcParentInfo(rels)
                .then((result) => {
                    this.parentInfoList = result;
                });
        } else {
            return this.$q.when();
        }
    }

    LoadChildrenInfo() {
        if (_.any(this.childRelationships)) {
            return this.dateCalcService.getDateMathCalcChildrenInfo(this.childRelationships)
                .then((result) => {
                    this.childrenInfoList = result;
                });
        } else {
            return this.$q.when();
        }
    }

    GetPriorToText(value: boolean) {
        var text = "";

        switch (value) {
            case true:
                text = "Before";
                break;
            case false:
                text = "After";
                break;
        }

        return text
    }


}
